<template>
  <div>
    <!--列表-->
    <el-container class="list-wrapper">
      <el-main class="table-wrap">
        <div style="margin-bottom: 10px; float: right" v-show="colorIndex == 0">
          <el-button class="green-btn"  size="mini" @click="adjustProcess('Y')">接受</el-button>
          <el-button class="orange-btn" size="mini" @click="adjustProcess('N')">拒绝</el-button>
        </div>
        <div class="tabText">
          <span 
            v-for="(item,index) in ['未处理消息','已处理消息']" 
            :key="index" 
            :class="colorIndex == index ? 'textColor' : ''"
            @click="tabTextClick(index)"
            >{{item}}</span>
        </div>
        <el-table
          stripe
          border
          ref="table"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          highlight-current-row
          :data="tableData.list || []"
          :height="tableHeight"
          v-if="tableHeight && tableShow"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          :row-key="(row) => row.dataId"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true" v-if="colorIndex == 0"></el-table-column>
          <el-table-column label="商品编码" prop="goodsCode" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column label="商品名称" prop="goodsName" show-overflow-tooltip width="250"></el-table-column>
          <el-table-column label="申请调整店铺" prop="applyStoreName"></el-table-column>
          <el-table-column label="调整量" prop="adjustNumber"></el-table-column>
          <el-table-column label="接收店铺" prop="acceptStoreName"></el-table-column>
          <el-table-column label="操作人" prop="applyPerson"></el-table-column>
          <el-table-column label="操作时间" prop="creationDate" show-overflow-tooltip width="200"></el-table-column>
          <el-table-column label="是否接受" prop="processStatus" v-if="colorIndex == 1"></el-table-column>
        </el-table>
      </el-main>
      <el-footer height="auto" style="text-align: right; padding-bottom: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import moment from "moment";
export default {
  name: "newProductSales",
  model: { 
    prop: 'searchForm',
    event: 'input'
  },
  components: {},
  props: ['searchForm', 'storeList'],
  data() {
    return {
      header_H: "38px",
      loading: false,
      exportLoading: false,
      tableShow: true,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      activeTable: 0,
      colorIndex: 0,
      queryCriteria: [],
      multipleSelection: [],
      currencyForm: {
        pageSize: 30,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'Y',
        groupAttr: '',
      },
    };
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 275;
    },
    windowWidth() {
      return document.body.clientWidth;
    },
  },
  methods: {
    onSearch() {
      this.$refs.table.clearSelection();
      this.tableData.pageNum = 1
      this.init()
    },
    async init() {
      if(this.colorIndex == 0) {
        this.unreadInit()
      }else {
        this.readInit()
      }
    },
    unreadInit() {
      this.loading = true
      let data = {...this.currencyForm}
      let queryMatch = [{
        attributeName: 'storeCode', //赠品编码
        val:  [this.searchForm.storeCode],
        op: 'in'
      }]
      data.queryMatch =  this.searchForm.storeCode ? queryMatch : []
      data.reportCode = 'clearStockStoreUnProcessMessage'
      data.pageSize = this.tableData.pageSize
      data.pageNum = this.tableData.pageNum
      this.searchFormData = data
      axios.post(`/ec-pc-api/custom/reports/data/clearStockStoreUnProcessMessage`,data).then(res => {
        if(res.code == 200) {
          this.tableData = res.data
        } 
      }).finally(() => {
        this.loading = false
      });
    },
    readInit() {
      this.loading = true
      let params = {
        storeCode: this.searchForm.storeCode,
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
      }
      // this.searchFormData = data
      this.$q.clearanceManagement.processedMessageSearch({data: params}).then(res => {
        if(res.code == 200) {
          this.tableData = res.data
          this.tableData.list = res.data.records
        } 
      }).finally(() => {
        this.loading = false
      });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      this.colorIndex = 0
      let searchForm = {
        status: '',
        storeCode: this.storeList[0].storeCode,
      };
      this.$emit('input',searchForm)
      this.tableData.pageNum = 1
      // this.$nextTick(_=>{
      //   this.onSearch()
      // })
      this.$emit('stroeChange')
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    adjustProcess(type) {
      if(!this.multipleSelection.length) {
        this.$message.error('请选择商品后在进行操作!')
        return
      }
      let data = {
        acceptType: type,
        dataIdList: this.multipleSelection.map(v=>v.dataId)
      }
      this.$q.clearanceManagement.adjustProcess({data: data}).then(res => {
        if(res.code == 200) {
          let message = type == 'Y' ? '接收成功' : '拒绝成功'
          this.$message.success(message)
          if(this.tableData.total == this.multipleSelection.length) {
            this.$emit('messageStatus')
          }
          this.onSearch()
        }
      })
    },
    
    tabTextClick(index) {
      this.colorIndex = index
      this.tableShow = false
      this.$nextTick(() => {
        this.tableShow = true
      })
      this.onSearch()
    },
     // 导出
    exportExcel() {
      console.log(this.searchFormData)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData
        },
        reportName: this.reportName
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.onSearch()
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form--inline .el-form-item:last-child {
  margin-right: 0;
}

.list-wrapper {
  background-color: #ffffff;
  border-radius: 6px;
}

.header-redio {
  margin: 10px;
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

.table-wrap {
  padding: 10px;
  border-radius: 6px;
}

.tabText {
  float: left
  // clear: both
  margin: 5px 0 13px 0
  font-size: 14px
    span {
      margin-right: 30px
      cursor: pointer
    }
}
.textColor {
  color: #03A9F4
}

>>> .el-link.el-link--primary {
  margin-right: 5px;
}
</style>
